import React from "react";
import { DesktopFilters } from "./DesktopFilter";
import { MobileFilters } from "./MobileFilters";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";
import { useFilterPanels } from "./useFilterPanels";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { useRouter } from "next/router";
import { customEvents, purchaseSeatsTabUIDs } from "@/global/config/constants";
import { useEventHandler } from "@/shared/base/hooks/useEventHandler";
import { useAppStore } from "@/global/store";
import { isFiltersApplied } from "./utils.gameFilters";

export function GameFilters() {
  const { md: mdDown } = useCssMediaQuery("down");
  const {
    filterPanels,
    handleSelectFilter,
    handleClearFilters,
    selectedFilter,
    isDisabledInteractiveToggle,
  } = useFilterPanels();
  const { uiConfigs } = useTeamConfig();
  const { query } = useRouter();
  const gameFilters = useAppStore((s) => s.data.gameFilters);
  const purchaseSeatTab = query.purchaseSeatTab as string;
  const isClearFiltersEnabled =
    purchaseSeatTab === purchaseSeatsTabUIDs.findGames &&
    isFiltersApplied(gameFilters);

  useEventHandler({
    name: customEvents.openGameFilter,
    handler: (event: any) => {
      const filterName = event?.detail?.name;
      if (selectedFilter !== filterName) {
        handleSelectFilter(filterName);
      }
    },
  });

  if (
    uiConfigs?.gameFiltersSettings?.hideGameFiltersOnFindGames &&
    purchaseSeatTab === purchaseSeatsTabUIDs.findGames
  )
    return null;

  return (
    <>
      {mdDown && (
        <MobileFilters
          selectedFilter={selectedFilter}
          onClickFilterButton={handleSelectFilter}
          filterPanels={filterPanels}
          onClearFilters={handleClearFilters}
          isClearFiltersButtonVisible={isClearFiltersEnabled}
        />
      )}

      {!mdDown && (
        <DesktopFilters
          selectedFilter={selectedFilter}
          onSelect={handleSelectFilter}
          filterPanels={filterPanels}
          isDisabledInteractiveToggle={isDisabledInteractiveToggle}
          onClearFilters={handleClearFilters}
          isClearFiltersButtonVisible={isClearFiltersEnabled}
        />
      )}
    </>
  );
}
